module.exports = __webpack_public_path__ + "static/media/almBg.2ba61d9c.png";